<template>
  <div id="contenedor-listado-tipo-archivos-contratista-desktop">
    <tool-bar v-on:nuevoTipoArchivoContratista="agregarNuevoTipoArchivoContratista"> </tool-bar>
    <v-data-table
      :headers="headers"
      :items="getTiposArchivosContratista"
      disable-pagination
      hide-default-footer
    >
      <template v-slot:[`item.acciones`]="{ item }">
        <opciones :tipoArchivoContratista="item"></opciones>
      </template>
    </v-data-table>
    <!-- Ventana Agregar Tipo Archivo Contratista -->
    <v-dialog
      v-if="mostrarVentanaAgregarTipoArchivoContratista"
      v-model="mostrarVentanaAgregarTipoArchivoContratista"
      persistent
      width="600"
    >
      <agregar-tipo-archivo-contratista v-on:cerrar="cerrarVentana">
      </agregar-tipo-archivo-contratista>
    </v-dialog>
    <!-- Ventana Editar Tipo Archivo Contratista -->
    <v-dialog
      v-if="esteTipoArchivoContratista"
      v-model="mostrarVentanaEditarTipoArchivoContratista"
      scrollable
      persistent
      width="600"
    >
      <editar-tipo-archivo-contratista
        :tipoArchivoContratistaEditar="esteTipoArchivoContratista"
        v-on:cerrar="cerrarVentana"
      >
      </editar-tipo-archivo-contratista>
    </v-dialog>
    <!-- Ventana Eliminar Tipo Archivo Contratista -->
    <v-dialog
      v-if="esteTipoArchivoContratista"
      v-model="mostrarVentanaEliminarTipoArchivoContratista"
      scrollable
      persistent
      width="400"
    >
      <eliminar-tipo-archivo-contratista
        :tipoArchivoContratistaEliminar="esteTipoArchivoContratista"
        v-on:cerrar="cerrarVentana"
      >
      </eliminar-tipo-archivo-contratista>
    </v-dialog>
  </div>
</template>

<script>
import CATALOGO_TIPOS_ARCHIVO_CONTRATISTA from '@/graphql/querys/administracion/contratos/contrato/archivos-contratista/tipos-archivivos-contratista/catalogoTiposArchivosContratista.gql';
import AgregarTipoArchivoContratista from '@/components/administracion/contratos/contrato/archivoscontratista/tipoarchivoscontratista/Agregar.vue';
import EditarTipoArchivoContratista from '@/components/administracion/contratos/contrato/archivoscontratista/tipoarchivoscontratista/Editar.vue';
import EliminarTipoArchivoContratista from '@/components/administracion/contratos/contrato/archivoscontratista/tipoarchivoscontratista/Eliminar.vue';
import ToolBar from './ToolBar.vue';
import Opciones from './Opciones.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoTipoArchivosContratistaDesktop',
  components: {
    AgregarTipoArchivoContratista,
    EditarTipoArchivoContratista,
    EliminarTipoArchivoContratista,
    ToolBar,
    Opciones,
  },
  apollo: {
    catalogoTiposArchivosContratista: {
      query: CATALOGO_TIPOS_ARCHIVO_CONTRATISTA,
    },
  },
  data() {
    return {
      mostrarVentanaAgregarTipoArchivoContratista: false,
      mostrarVentanaEditarTipoArchivoContratista: false,
      mostrarVentanaEliminarTipoArchivoContratista: false,
      esteTipoArchivoContratista: null,
      headers: [
        { text: 'Descripción', sortable: false, value: 'descripcion' },
        { text: 'Orden', sortable: false, value: 'orden' },
        {
          text: '',
          align: 'end',
          sortable: false,
          value: 'acciones',
        },
      ],
    };
  },
  mounted() {
    eventBus.$on('editar-tipo-archivo-contratista', (tipoArchivoContratista) => {
      this.mostrarVentanaEditarTipoArchivoContratista = true;
      this.esteTipoArchivoContratista = tipoArchivoContratista;
    });
    eventBus.$on('eliminar-tipo-archivo-contratista', (tipoArchivoContratista) => {
      this.mostrarVentanaEliminarTipoArchivoContratista = true;
      this.esteTipoArchivoContratista = tipoArchivoContratista;
    });
  },
  methods: {
    cerrar() {
      this.$emit('cerrar');
    },
    cerrarVentana() {
      this.mostrarVentanaAgregarTipoArchivoContratista = false;
      this.mostrarVentanaEditarTipoArchivoContratista = false;
      this.mostrarVentanaEliminarTipoArchivoContratista = false;
      this.esteTipoArchivoContratista = null;
    },
    agregarNuevoTipoArchivoContratista() {
      this.mostrarVentanaAgregarTipoArchivoContratista = true;
    },
  },
  computed: {
    getTiposArchivosContratista() {
      if (!this.catalogoTiposArchivosContratista) return [];
      return this.catalogoTiposArchivosContratista
        .slice()
        .sort((a, b) => a.orden - b.orden);
    },
  },
};
</script>

<style lang="scss"></style>
